<template>
  <label
    class="tw-flex tw-items-center tw-align-start tw-gap-1"
    :class="[props.disabled ? 'tw-cursor-not-allowed' : 'tw-cursor-pointer']"
  >
    <span
      v-if="!props.labelRightToToggle && props.label"
      class="tw-ml-2 tw-mr-2"
    >
      <div v-html="t(props.label)" />
    </span>
    <div class="tw-flex tw-items-center">
      <div class="tw-relative tw-w-12 tw-h-6 tw-bg-gray-200 tw-rounded-full tw-transition-colors tw-duration-200 tw-ease-in-out tw-overflow-hidden">
        <div
          class="tw-absolute tw-inset-0 tw-w-6 tw-h-6 tw-rounded-full tw-shadow-md tw-transition-transform tw-duration-200 tw-ease-in-out"
          :class="{
            'tw-translate-x-6': active,
            'tw-bg-primary-500': active && !props.disabled,
            'tw-bg-gray-400': !active || props.disabled,
            'tw-border-solid tw-border-red-500': props.hasValidationError,
          }"
        />
        <input
          :disabled="props.disabled"
          type="checkbox"
          :name="props.name"
          :id="props.name"
          class="tw-absolute tw-right-full tw-bottom-full"
          v-model="active"
        />
      </div>
    </div>
    <span
      v-if="labelRightToToggle && props.label"
      class="tw-ml-2 tw-mr-2"
    >
      <div v-html="t(props.label)" />
    </span>
  </label>
</template>

<script setup lang="ts">
import { useTranslation } from 'i18next-vue';

const { t } = useTranslation();

const active = defineModel<boolean>({ default: true });

const props = defineProps<{
  labelRightToToggle?: boolean;
  label?: string;
  disabled?: boolean;
  hasValidationError?: boolean;
  name?: string;
}>();
</script>
